import { actionTypes } from './actions';

const initialState = {
  politeMessage: '',
  assertiveMessage: '',
};

const liveRegion = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CLEAR_MESSAGES:
      return {
        ...state,
        politeMessage: '',
        assertiveMessage: '',
      };
    case actionTypes.ANNOUNCE_POLITE_MESSAGE:
      return {
        ...state,
        politeMessage: action.payload,
      };
    case actionTypes.ANNOUNCE_ASSERTIVE_MESSAGE:
      return {
        assertiveMessage: action.payload,
      };
    default:
      return state;
  }
};

export default liveRegion;
